import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AbsencesAndTruancyReportRoute extends Route {
  @service
  router;

  // Redirect to the new absences and truancy report
  beforeModel(transition) {
    this.router.transitionTo(
      'admin.lists.attendance.absences-and-truancy-report',
      { queryParams: transition.to.queryParams },
    );
  }
}
